import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { User } from '@features/users/models/user.model';
import { JWTTokenValidation } from '@shared/enums/global.enum';
 import { Mapper } from './base-mapper.service';
import { StorageConstant } from '@shared/constants/storage.constant';

@Injectable({
  providedIn: 'root',
})
export class JwtDecoderService {
  constructor(private jwtHelperService: JwtHelperService, private mapper: Mapper) {}

  saveToken(authUSer: string) {
    if (authUSer) {
      try {
        localStorage.setItem(StorageConstant.AUTH_USER, authUSer);
      } catch (e) {
        console.warn('localStorage blocked (sandboxed iframe, strict browser privacy settings)', e);
      }
    }
  }

  removeCurrentToken() {
    try {
      localStorage.removeItem(StorageConstant.AUTH_USER);
    } catch (e) {
      console.warn('localStorage blocked (sandboxed iframe, strict browser privacy settings)', e);
    }
  }

  isThereValidToken(): JWTTokenValidation {
    const user = this.getCurrentUserFromJWTToken();
    if (user) {
      if (this.isTokenExpired(user.accessToken)) {
        return JWTTokenValidation.Expired;
      } else {
        return JWTTokenValidation.Valid;
      }
    }
    return JWTTokenValidation.NotFound;
  }

  isTokenExpired(authToken) {
    return authToken == null || this.jwtHelperService.isTokenExpired(authToken);
  }

  getDecodedToken() {
    try {
      const user = localStorage.getItem(StorageConstant.AUTH_USER);
      return JSON.parse(user);
    } catch (e) {
      console.warn('localStorage blocked (sandboxed iframe, strict browser privacy settings)', e);
      return null;
    }
  }

  getDeviceIdFromToken(token: string): string {
    if (!token) {
      return null;
    }
    try {
      return this.jwtHelperService.decodeToken(token)?.deviceId || null;
    } catch {
      return null;
    }
  }

  getCurrentUserFromJWTToken() {
    const payloadMap = this.getDecodedToken();
    if (payloadMap != null) {
      return this.mapper.fromJson(User, payloadMap);
    }
    return null;
  }
}
